export default "__VITE_ASSET__CL_7AWXW__"